import AppButton from "@/components/AppButton.vue";
import EmptyState from "@/components/EmptyState.vue";
import HeaderFluxo from "@/components/HeaderFluxo.vue";
import StoreCard from "@/components/HorizontalStoreCard.vue";
import InputText from "@/components/InputText.vue";
import LoadingPhases from "@/components/LoadingPhases.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import TextLink from "@/components/TextLink.vue";
import { getApplicationUrl } from "@/config";
import HomeContainer from "@/containers/HomeContainer.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import moment from "moment";
import CircleButton from "orders-module/src/components/CircleButton.vue";
import HeaderCircleButton from "orders-module/src/components/HeaderCircleButton.vue";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    HeaderColor,
    HeaderCircleButton,
    CircleButton,
    TextLink,
    InputText,
    AppButton,
    HeaderFluxo,
    StoreCard,
    ModalCodigo,
    EmptyState,
    LoadingPhases,
    HomeContainer,
  },
})
export default class Lojas extends Vue {
  stores: any = JSON.parse(sessionStorage.getItem("stores") || "[]") || [];
  filteredStores: any = this.stores;
  storesLoaded = false;
  showModalTelaCartoes = false;
  mainCartao: any = JSON.parse(sessionStorage.getItem("MAIN_CARTAO") || "{}");
  card: any;
  creditCards: Array<object> = [];
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "[]");
  lastDate: any = sessionStorage.getItem("LAST_DAY_ESCOLHER_UNIDADE") || "";
  chooseStructure: any =
    sessionStorage.getItem("NEED_TO_CHOOSE_THE_STRUCTURE") || "1";
  userAddress: any = {};
  formattedAddress = "";
  showModal = false;
  currentLatitude: any = "";
  currentLongitude: any = "";
  useCurrentLocation = false;
  emptyStateMessage = "Carregando lojas próximas...";
  homeLayout = sessionStorage.getItem("HOME_LAYOUT");
  componentKey = 0;
  notificationsKey = 1;
  logo = sessionStorage.getItem("ORGANIZATION_LOGO") || "";
  deliveryAt = sessionStorage.getItem("DELIVER_AT") || "B";
  isStore = sessionStorage.getItem("GO_TO_STORE") || "";
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    show: true,
    callback: this.goBack,
  };
  storeLoadedId = Number(sessionStorage.getItem("STORE_LOADE_ID"));
  store: any = JSON.parse(sessionStorage.getItem("STORE") || "{}");
  loadedStores: boolean = sessionStorage.getItem("stores") ? true : false;

  get filteredStoresByDelivery() {
    return this.filteredStores.filter((store: any) => {
      switch (this.deliveryAt) {
        case "B":
          return store.deliversToBalcony;
        case "A":
          return store.deliversToAddress;
        case "I":
          return store.deliversToInternalLocation;
        default:
          return true;
      }
    });
  }

  created() {
    if (this.homeLayout == "Lojas") {
      sessionStorage.setItem("HAS_HOME", "true");
    }
    if (this.userData.ADDRESS)
      this.userAddress = this.userData.ADDRESS.find(
        (address: any) => address.TYPE == "DELIVERY"
      );
    else if (sessionStorage.getItem("PROVISORY_ADDRESS"))
      this.userAddress =
        JSON.parse(sessionStorage.getItem("PROVISORY_ADDRESS") || "{}") || {};
    if (this.userAddress && this.userAddress.PROVINCY == "DF") {
      this.formattedAddress = Util.capitalize(this.userAddress.STREET);
    } else {
      this.formattedAddress =
        this.userAddress && this.userAddress.STREET
          ? Util.capitalize(this.userAddress.STREET) +
            ", " +
            this.userAddress.NUMBER
          : "";
    }
    this.useCurrentLocation = JSON.parse(
      sessionStorage.getItem("USE_CURRENT_LOCATION") || "false"
    );
  }

  mounted() {
    sessionStorage.removeItem("INITIAL_SCROLL_POSITION");
    if (sessionStorage.getItem("DELIVER_AT") == "A") {
      this.deliveryAt = "A";
    }

    if (this.useCurrentLocation) {
      this.getCurrentLocation();
    } else this.getStores();
    Util.setBackButtonBehavior(this.goBack);

    if (!this.stores) {
      this.prepareStores(this.stores);
    }

    this.getCreditCards();
    sessionStorage.setItem("currentOrder", "");
    sessionStorage.setItem("currentItem", "");
    sessionStorage.setItem("ALL_PAYMENT_METHODS", "[]");
    sessionStorage.setItem("METHOD_SELECTED", "");
    sessionStorage.setItem("FULL_METHOD_SELECTED", "{}");
    sessionStorage.removeItem("CURRENT_TIME_SHEET");
    sessionStorage.removeItem("CURRENT_TIME_TIME_SHEET");
    sessionStorage.removeItem("DELIVERY_DATA");
  }

  getStructures() {
    return new Promise((resolve: Function) => {
      try {
        const req = new Request();
        req.body = {
          NRORG: sessionStorage.getItem("NRORG"),
          STRUCTURE_LEVEL: 0,
        };
        req.route = "getStructures";
        req.callbackSuccess = async (response: any) => {
          const structures = response.structures;
          sessionStorage.setItem("STRUCTURES", JSON.stringify(structures));

          const result1 = await this.setStructure();
          const day = JSON.stringify(moment().date());
          const chooseStructure = sessionStorage.getItem(
            "NEED_TO_CHOOSE_THE_STRUCTURE"
          );

          if (result1 && chooseStructure == "1") {
            if (!this.lastDate || day != this.lastDate) {
              this.$router.push("EscolherUnidade");
            }
            if (!sessionStorage.getItem("STRUCTURE_ID")) {
              this.$router.push("EscolherUnidade");
            }
          }
          resolve(true);
        };
        req.callbackError = function (error: any) {
          console.log(error);
        };
        req.blockTouchEvents = false;
        req.send();
      } catch (e) {
        console.log(e);
      }
    });
  }

  setStructure() {
    return new Promise((resolve: Function) => {
      const structures = sessionStorage.getItem("STRUCTURES");
      if (structures) {
        const arrayStructures = JSON.parse(structures);

        if (arrayStructures.length == 1) {
          sessionStorage.setItem("STRUCTURE_NAME", arrayStructures[0].name);
          sessionStorage.setItem("STRUCTURE_ID", arrayStructures[0].id);
          sessionStorage.setItem("NEED_TO_CHOOSE_THE_STRUCTURE", "0");
          resolve(true);
        } else {
          sessionStorage.setItem("NEED_TO_CHOOSE_THE_STRUCTURE", "1");
          resolve(false);
        }
      }
    });
  }

  horarioFuncionamento(day: any) {
    const date = moment().day();
    const workTime = day.filter((d: any) => d.DAY == date);
    return workTime;
  }

  verifyMainCard() {
    this.mainCartao = this.userData.MAIN_CARD_ID;
    this.card = this.findMainCard(this.mainCartao, this.creditCards);
    if (!this.card) this.showModalTelaCartoes = true;
  }

  findMainCard(mainCartao: number, cards: any) {
    return cards.find((card: any) => card.ID == mainCartao);
  }

  goBack() {
    const homeLayout = this.verifyRouteHome();
    this.$router.push(homeLayout);
  }

  fechaModal() {
    this.showModal = false;
  }

  changeStructure() {
    this.$router.push("EscolherUnidade");
  }

  async getIfStoreHasAnySubmenu(storeId: number) {
    const request = new Request();
    request.route = `getIfStoreHasAnySubmenu?requestType=FilterData&STORE_ID=${storeId}`;
    request.showLoader = false;
    try {
      const response = await request.get();
      return response.ifStoreHasAnySubmenu.ifHasSubmenu;
    } catch (error) {
      console.error(error);
    }
  }

  selectStore(storeId: number) {
    const oldStoreId = sessionStorage.getItem("storeId")
      ? sessionStorage.getItem("storeId")
      : 0;
    sessionStorage.setItem("SHOW_ORDERBUTTON", JSON.stringify(false));
    sessionStorage.removeItem("STRUCTURE_ID");
    sessionStorage.removeItem("CLICK_PRODUCT");
    if (sessionStorage.getItem("STORE")) {
      if (this.store.id != storeId) {
        sessionStorage.removeItem("STORE");
        sessionStorage.removeItem("CURRENT_ORDER");
        sessionStorage.removeItem("ITEMS");
        sessionStorage.removeItem("DELIVERY_DATA");
      } else {
        sessionStorage.removeItem("STORE");
      }
    }
    if (!sessionStorage.getItem("CAME_FROM_RELEASE")) {
      sessionStorage.removeItem("DELIVER_AT");
      sessionStorage.removeItem("deliversToTable");
      sessionStorage.removeItem("deliversToBalcony");
      sessionStorage.removeItem("deliversToAddress");
      sessionStorage.removeItem("deliversToInternalLocation");
    }
    sessionStorage.setItem("storeId", storeId.toString());
    sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
    if (
      sessionStorage.getItem("CURRENT_ORDER") &&
      storeId.toString() != sessionStorage.getItem("storeId")
    ) {
      sessionStorage.setItem("CURRENT_ORDER", "{}");
    }
    this.getIfStoreHasAnySubmenu(storeId).then((response: any) => {
      if (response) {
        sessionStorage.getItem("STORE")
          ? this.$router.push("Produtos")
          : this.goProducts();
      } else {
        sessionStorage.getItem("STORE")
          ? this.$router.push("ListaDeProdutos")
          : this.goProducts("ListaDeProdutos");
      }

      if (oldStoreId != storeId) {
        this.getCreditCards();
      }
    });
  }

  goProducts(path = "Produtos") {
    sessionStorage.setItem("loadStore", JSON.stringify(true));
    this.$router.push(path);
  }

  getStoreData() {
    try {
      const self = this;
      const storeId = String(sessionStorage.getItem("storeId"));
      const req = new Request();
      req.body = {
        STORE_ID: sessionStorage.getItem("storeId"),
        ALL_MENUS: "NO",
        DEVICE_TIME: self.getDeviceTime(),
      };
      req.route = "getStoreData";
      req.callbackSuccess = (response: any) => {
        sessionStorage.setItem("STORE_LOADED", "true");
        sessionStorage.setItem("STORE_LOADE_ID", storeId);
        sessionStorage.setItem(
          "MOMENT_LOADED",
          moment().format("Y-MM-DD HH:mm:ss")
        );
        sessionStorage.setItem(
          "ACCEPTED_PAYMENT_METHODS",
          JSON.stringify(response.store.paymentMethods)
        );
        sessionStorage.setItem(
          "deliversToTable",
          response.store.deliversToTable
        );
        sessionStorage.setItem(
          "deliversToBalcony",
          response.store.deliversToBalcony
        );
        sessionStorage.setItem(
          "deliversToInternalLocation",
          response.store.deliversToInternalLocation
        );
        sessionStorage.setItem(
          "deliversToAddress",
          response.store.deliversToAddress
        );
        sessionStorage.setItem(
          "storePaymentMoment",
          response.store.paymentMoment
        );
        sessionStorage.setItem("STORE", JSON.stringify(response.store));
        sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
        this.$router.push("Produtos");
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.showLoader = false;
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  getModifiedAtStore() {
    try {
      const req = new Request();
      req.body = {
        STORE_ID: sessionStorage.getItem("storeId"),
        ALL_MENUS: "NO",
        ONLY_MODIFIED_AT: true,
      };
      req.route = "getStoreData";
      req.callbackSuccess = (response: any) => {
        const modifiedAt = response.onlyModifiedAt.modifiedAt.date;
        sessionStorage.setItem("MOMENT_STORE", modifiedAt);
        if (sessionStorage.getItem("STORE_LOADED")) {
          const getStoreLoaded = String(
            sessionStorage.getItem("MOMENT_LOADED")
          );
          const getModifiedAtStore = modifiedAt;
          console.log(getStoreLoaded);
          console.log(getModifiedAtStore);
          const date1 = new Date(getStoreLoaded);
          const date2 = new Date(getModifiedAtStore);
          if (date1.getTime() < date2.getTime()) {
            sessionStorage.setItem("RELOAD_STOREDATA", "true");
            this.getStoreData();
          }
        }
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  getStores() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        NRORG:
          sessionStorage.getItem("NRORG") == "0"
            ? null
            : sessionStorage.getItem("NRORG"),
        STRUCTURE_ID: null,
        LATITUDE: sessionStorage.getItem("LATITUDE"),
        LONGITUDE: sessionStorage.getItem("LONGITUDE"),
        SHOPPING: sessionStorage.getItem("SHOPPING"),
        DEVICE_TIME: Util.getDeviceTime(),
        URL: getApplicationUrl(),
      };
      req.route = "getStoresNearUser";
      req.callbackSuccess = (response: any) => {
        const stores = response.stores;
        self.prepareStores(stores);
        sessionStorage.setItem("stores", JSON.stringify(self.stores));
        this.loadedStores = true;
        if (this.stores && this.stores.length > 0) {
          if (this.stores.length == 1) {
            this.selectStore(this.stores[0].id);
            if (this.stores[0].deliversToAddress == false) {
              this.emptyStateMessage =
                "Desculpe, no momento ainda não atendemos sua região nessa modalidade de entrega.";
            }
          }
        } else {
          this.emptyStateMessage =
            "Desculpe, no momento ainda não atendemos sua região nessa modalidade de entrega.";
          this.prepareStores(this.stores);
        }
      };
      req.callbackError = function (error: any) {
        self.emptyStateMessage =
          "Não foi encontrada nenhuma loja aberta no momento nesta unidade.";
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  prepareStores(stores: any) {
    const openedStores = stores.filter((s: any) => s.opened == true);
    const closedStores = stores.filter((s: any) => s.opened == false);

    stores = openedStores.concat(closedStores);

    this.stores = stores;
    this.filteredStores = stores;
    this.storesLoaded = true;
  }

  getCreditCards() {
    try {
      if (sessionStorage.getItem("USER_ID")) {
        const self = this;
        const req = new Request();
        req.body = {
          USER_ID: sessionStorage.getItem("USER_ID"),
          TOKEN: sessionStorage.getItem("TOKEN"),
          NRORG: sessionStorage.getItem("NRORG"),
          STORE_ID: this.store.id,
        };
        req.route = "getValidCreditCard";
        req.callbackSuccess = function (response: any) {
          const creditCards = response.creditcards;
          self.creditCards = creditCards;
          if (response.creditcardFromParent)
            self.creditCards.push(response.creditcardFromParent);

          self.mainCartao = {};
          creditCards.forEach((card: any) => {
            if (card.IS_MAIN_CARD == true) self.mainCartao = card;
          });

          if (!self.mainCartao && !self.mainCartao.FLAG) self.mainCartao = true;
        };
        req.callbackError = function (error: any) {
          console.log(error);
          self.creditCards = [];
          self.mainCartao = {};
        };
        req.blockTouchEvents = false;
        req.showLoader = false;
        req.send();
      }
    } catch (e) {
      console.log(e);
    }
  }

  telaCartoes() {
    this.$router.push("RegisteredCards");
  }

  goToAddAddress() {
    sessionStorage.setItem("ENTERED_ADD_ADDRESS_FROM", "Lojas");
    this.$router.push("AddAddress");
  }

  returnToHomeAndOpenModal() {
    const homeLayout = this.verifyRouteHome();

    if (homeLayout == "HomeFeed" || homeLayout == "HomeRelease") {
      sessionStorage.setItem("NO_ADDRESS_MODAL", "true");
      this.$router.replace(homeLayout);
    } else {
      this.$router.replace(homeLayout);
    }
  }

  getCurrentLocation() {
    navigator.geolocation.getCurrentPosition(
      (location: any) => {
        this.currentLatitude = location.coords.latitude;
        this.currentLongitude = location.coords.longitude;
        this.getStores();
      },
      this.getStores,
      { timeout: 1000 }
    );
  }

  verifyRouteHome() {
    const homeLayout: any = Util.verifyRouteHome();
    return homeLayout;
  }

  getDeviceTime() {
    moment.locale("pt-br");
    const deviceTime: any = moment().format("LT");
    return deviceTime;
  }

  searchStores(searchStore: string) {
    this.filteredStores = this.stores.filter((store: any) =>
      store.name.toLowerCase().includes(searchStore.toLowerCase())
    );
    this.emptyStateMessage =
      "Não encontramos resultados correspondentes à sua pesquisa.";
  }
}
